import React from "react"
import { TAB_FILTER_FIELDS } from "./constants"
import { X } from "lucide-react"

const Chip = ({ label, onRemove }) => (
  <div className="flex items-center gap-1 px-2 py-0.5 bg-orange-50 border border-orange-200 rounded-full">
    <span className="text-xs text-orange-700 max-w-[80px] truncate">{label}</span>
    <button onClick={onRemove} className="flex-shrink-0 hover:text-red-500 transition-colors">
      <X className="w-3 h-3 text-orange-400" />
    </button>
  </div>
)

const ActiveChips = ({ filters, activeTab, onFilterChange, onFilterReset, departments, t }) => {
  const fields = TAB_FILTER_FIELDS[activeTab] ?? []
  const chips = []

  if (fields.includes("status") && filters.status !== "")
    chips.push(
      <Chip key="status" label={filters.status} onRemove={() => onFilterChange("status", "")} />
    )

  if (fields.includes("state_id") && filters.state_id > 0)
    chips.push(
      <Chip
        key="state_id"
        label={`${t("admin.state")}: ${filters.state_id}`}
        onRemove={() => onFilterChange("state_id", 0)}
      />
    )

  if (fields.includes("departament_id") && filters.departament_ids?.length > 0)
    chips.push(
      <Chip
        key="departament_ids"
        label={`${t("admin.departament")}: ${filters.departament_ids.length}`}
        onRemove={() => onFilterChange("departament_ids", [])}
      />
    )

  if (fields.includes("company_id") && filters.company_id > 0)
    chips.push(
      <Chip
        key="company_id"
        label={`${t("devise.company")}: ${filters.company_id}`}
        onRemove={() => onFilterChange("company_id", 0)}
      />
    )

  if (fields.includes("moderator_id") && filters.moderator_id > 0)
    chips.push(
      <Chip
        key="moderator_id"
        label={`${t("admin.moderator")}: ${filters.moderator_id}`}
        onRemove={() => onFilterChange("moderator_id", 0)}
      />
    )

  if (fields.includes("bundle_type") && filters.bundle_type)
    chips.push(
      <Chip
        key="bundle_type"
        label={`${t("admin.orders_type")}: ${filters.bundle_type}`}
        onRemove={() => onFilterChange("bundle_type", "")}
      />
    )

  if (fields.includes("message_theme") && filters.message_theme?.length > 0)
    chips.push(
      <Chip
        key="message_theme"
        label={`${t("admin.topics")}: ${filters.message_theme.length}`}
        onRemove={() => onFilterChange("message_theme", [])}
      />
    )

  if (fields.includes("date_range") && (filters.date_from || filters.date_to))
    chips.push(
      <Chip
        key="date_range"
        label={`${filters.date_from || "…"} — ${filters.date_to || "…"}`}
        onRemove={() => {
          onFilterChange("date_from", null)
          onFilterChange("date_to", null)
        }}
      />
    )

  if (fields.includes("search") && filters.search)
    chips.push(
      <Chip
        key="search"
        label={`"${filters.search}"`}
        onRemove={() => onFilterChange("search", "")}
      />
    )

  if (chips.length === 0) return null

  return (
    <div className="px-3 py-2 border-b border-slate-100 flex flex-wrap gap-1.5 flex-shrink-0">
      {chips}
      <button
        onClick={onFilterReset}
        className="text-xs text-slate-400 hover:text-red-500 transition-colors px-1"
      >
        {t("admin.reset_all")}
      </button>
    </div>
  )
}

export default ActiveChips
